/* global Proj */
/* global $ */

$(function() {
    'use strict';

    /* Инициализация приложения */
    Proj.init();

    Proj.Underlay();

    Proj.showSchemePopup();
    Proj.closeClick();
    Proj.headerMenu();
    Proj.showMoreCat();

    Proj.fancyGallery();

    Proj.Feedback({
        wrap:'#form_request_footer'
    });

    Proj.slickSlider({
        selector:'.js-clients-slider',
        dots: true,
        slidesToShow: 3
    });

    Proj.slickSlider({
        selector:'.js-equipment-slick',
        dots: true,
        arrows: true,
        slidesToShow: 5
    });

    Proj.slickSlider({
        selector:'.js-team-slick',
        dots: true,
        arrows: true,
        slidesToShow: 5
    });

    Proj.slickSlider({
        selector:'.js-production-slick',
        dots: true,
        arrows: true,
        slidesToShow: 5
    });

    Proj.slickSlider({
        selector:'.js-partners-slick',
        dots: true,
        arrows: true
    });

    Proj.relatedSlider();

    Proj.Variants();

    Proj.Calculator();

    Proj.Targets();

    Proj.formRequest();

    Proj.getProjects();


    if (Proj.interfaceName === 'deliverys_cat') {
        Proj.Shipment();
    }

    /* Инициализация частей приложения в зависимости от типа страницы */
    // if(
    //     (Proj.interfaceName === 'project_group')
    //     ||
    //     (Proj.interfaceName === 'about_page')
    // ){

    // }

    /* Перебрать */
    Proj.Shit.ProdFotorama();
    Proj.Shit.selectColor();
    Proj.Shit.showColorCatPopup();
    Proj.Shit.prodSliderInit();
    Proj.Shit.greatSpagetti();
    Proj.Shit.greatestSpagetti();

    Proj.Map(); 
});
